import {
    LOAD_INDUCTION_SESSIONS,
    LOAD_INDUCTION_SESSIONS_SUCCESS,
    LOAD_INDUCTION_SESSIONS_FAILURE,
} from '../actions';

const initialState = {
    fetching: false,
    error: undefined,
    content: [],
    meta: undefined,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LOAD_INDUCTION_SESSIONS:
            return {
                ...state,
                error: undefined,
                fetching: true,
            };
        case LOAD_INDUCTION_SESSIONS_SUCCESS:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        case LOAD_INDUCTION_SESSIONS_FAILURE:
            return {
                ...state,
                content: action.payload.content,
                meta: action.payload.meta,
                fetching: false,
            };
        default:
            return state;
    }
};

export default reducer;
